module.exports = __webpack_public_path__ + "img/android_nfc_fail.c1db413d.svg";